import { render, staticRenderFns } from "./store-log-table.vue?vue&type=template&id=389e503b&scoped=true&"
import script from "./store-log-table.vue?vue&type=script&lang=js&"
export * from "./store-log-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e503b",
  null
  
)

export default component.exports